import { LoadStatusModel } from "@modules/shared/models/common";

export interface CompanyLoadStatusViewModel extends LoadStatusModel {
    isSearching: boolean;
    isSearched: boolean;
}